<template>
  <!-- TODO Dokończyć -->
  <div
    class="feature-photo-box"
    :class="backgroundColor ? '' : backgroundClass"
    :style="cssVars"
  >
    <template v-if="content.url.value">
      <a :href="content.url.value">

        <div class="feature-box-image">
          <ContentGeneratorElementsMedia
            :value="content.media"
            size-image="w2000"
            aspect-ratio="2 / 1"
            aspect-ratio-mobile="2 / 1"
          />
          <!-- TODO nazwa klasy do zmiany -->
          <div class="bg-img">
            <div
              class="title-icon"
              :class="textColor ? '' : textColorClass"
              :style="textColor ? `color: ${textColor}` : ''"
            >
              <ContentGeneratorElementsText :content="content.text" />
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_3649_783)">
                  <circle cx="20" cy="20" r="20" fill="#0066CC" />
                  <path
                    d="M12.9688 27.1875H27.0312"
                    stroke="white"
                    stroke-width="1.875"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M20 11.5625V23.2812"
                    stroke="white"
                    stroke-width="1.875"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.5312 17.8125L20 23.2812L25.4688 17.8125"
                    stroke="white"
                    stroke-width="1.875"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_3649_783">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </a>
    </template>
    <template v-else>
      <div class="feature-box-image">
        <ContentGeneratorElementsMedia
          :value="content.media"
          size-image="w2000"
          aspect-ratio="2/1"
          aspect-ratio-mobile="2/1"
        />
        <div class="bg-img">
          <div
            class="title-icon"
            :class="textColor ? '' : textColorClass"
            :style="textColor ? `color: ${textColor}` : ''"
          >
            <ContentGeneratorElementsText :content="content.text" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ContentGeneratorElementsText from '../elements/Text.vue'
import ContentGeneratorElementsMedia from '../elements/Media.vue'
import { contentFindContent, contentFindOption } from '../../../plugins/content'
export default {
  components: {
    ContentGeneratorElementsText,
    ContentGeneratorElementsMedia
  },
  props: {
    value: { type: Object, default: null }
  },
  computed: {
    content () {
      return {
        text: contentFindContent(this.value?.content, 'text'),
        media: contentFindContent(this.value?.content, 'media'),
        url: contentFindContent(this.value?.content, 'url')
      }
    },
    backgroundColor () {
      return contentFindOption(this.value.options, 'backgroundColor').value || null
    },
    backgroundClass () {
      return contentFindOption(this.value.options, 'backgroundClass').value || null
    },
    textColor () {
      return contentFindOption(this.value.options, 'textColor').value || null
    },
    textColorClass () {
      return contentFindOption(this.value.options, 'textColorClass').value || null
    },
    cssVars () {
      return {
        'background-color': this.backgroundColor
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.feature-photo-box {
  border-radius: 20px;
  width: 100%;
  overflow: hidden;

  a {
    cursor: pointer;
  }

  .feature-box-image {
    position: relative;
  }

  .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 20px;
    width: 100%;
    height: 100%;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    padding: 32px;

    .title-icon {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      width: 100%;

      :deep(.text) {
        & > :first-child {
          margin-top: 0;
        }

        & > :last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
